import React from 'react';
import Box from "../../Common/Box";
import ThreeScreen from "../ThreeScreen";
import uiStore from "../../lib/stores/uiStore";
import Messages from "../../Messages/Messages";
import Notification from "../../Common/Notification";
import {Slide} from "@mui/material";
import Paper from "@mui/material/Paper";
import Settings from "../../UserSettings/UserSettings";
import UserList from "../../Room/UserList";
import RoomList from "../../RoomList/RoomList";
import PopperUserInfo from "../../Common/UserInfo/PopperUserInfo";
import {observer} from "mobx-react";
import shadowClient from "../../lib/clients/shadow/shadowClient";
import Navbar from "./Navbar";

const DesktopMain = () => {

    const clientUser = shadowClient.getClientUser();

    return <Box
            expand
            row
            bgcolor={"background.default"}
            position={"relative"}
    >
        <Box position={"absolute"} expand>
            <ThreeScreen/>
        </Box>

        <Box position={"absolute"} expand row>

            <Box flex={1} overflow={"hidden"} column></Box>

            <Box
                    flex={1}
                    column
                    height={"100%"}
                    overflow={"auto"}
                    position={"relative"}
            >
                <Navbar/>
                <Box
                        flex={1}
                        row
                        padding={"10px"}
                        overflow={"auto"}
                >

                    <Box
                            maxWidth={"100%"}
                            flex={1}
                            maxHeight={"600px"}
                            height={"100%"}
                            minWidth={uiStore.isMobile ? "initial" : "400px"}
                            paddingLeft={"20px"}
                    >
                        <Messages/>
                        <Notification/>
                    </Box>
                </Box>
            </Box>

            <Box flex={1} position={"relative"}/>

        </Box>
        <Slide
                direction="right"
                in={uiStore.settingsVisible}
        >
            <Paper
                    elevation={5}
                    sx={{
                        position: "absolute",
                        pointerEvents: "all",
                        left: "0",
                        width: "25%",
                        height: "100%"
                    }}>
                {clientUser && <Settings clientUser={clientUser}/>}
            </Paper>
        </Slide>

        <Slide
                direction="left"
                in={uiStore.userListVisible}
        >
            <Paper
                    elevation={5}
                    sx={{
                        position: "absolute",
                        pointerEvents: "all",
                        right: "0",
                        width: "25%",
                        height: "100%"
                    }}>
                <UserList/>
            </Paper>
        </Slide>
        <Slide direction="left" in={uiStore.roomListVisible}
        >
            <Paper
                    elevation={5}
                    sx={{
                        pointerEvents: "all",
                        position: "absolute",
                        right: "0",
                        width: "25%",
                        height: "100%"
                    }}>
                <RoomList/>
            </Paper>
        </Slide>
        <PopperUserInfo/>
    </Box>
};

export default observer(DesktopMain);
